import { useCallback, useState } from 'react';
import { TagSummaryCitationsModal } from '@/components/ConferenceTag.Summary/Modal.Citations';
import type { ConferenceTagSummaryItem } from '@/types/conferences.tags';
import { useFetchProjectTagSummaryCitations } from '@/utils/api';
import { SummaryCitationsClickedContext } from './context';

type Props = ChildrenProps & IProjectId;

export const ProjectSummaryCitationsContainer = ({ children, projectId }: Props) => {

  const [openItem, setOpenItem] = useState<ConferenceTagSummaryItem>();
  const tagSummaryId = openItem?.summary.id;

  const {
    data,
    isLoading,
  } = useFetchProjectTagSummaryCitations({
    projectId,
    tagSummaryId,
  });

  const handleOpen = useCallback((item: ConferenceTagSummaryItem) => {
    setOpenItem(item);
  }, []);

  const handleClose = useCallback(() => {
    setOpenItem(null);
  }, []);

  const open = !!tagSummaryId;

  return (
    <SummaryCitationsClickedContext.Provider value={handleOpen}>
      {children}
      {open && (
        <TagSummaryCitationsModal
          projectId={projectId}
          summaryItem={openItem}
          open={open}
          onClose={handleClose}
          items={data.citations} />
      )}
    </SummaryCitationsClickedContext.Provider>
  );
};